/**
 * Componente que muestra un mensaje de error cuando el servicio de búsqueda no está disponible.
 * Se renderiza cuando el API retorna un código de estado 503 (Service Unavailable).
 * 
 * @component
 * @returns {JSX.Element} Mensaje de error estilizado para mostrar al usuario
 * 
 * @example
 * // Uso típico en el componente padre
 * {serviceError && <ErrorService />}
 */
export default function ErrorService() {
  return (
    <div className="error-message" style={{ padding: '20px', textAlign: 'center', color: '#d32f2f' }}>
      <br></br>
      <h3>Servicio no disponible</h3>
      <p>Por favor, inténtalo de nuevo en unos momentos.</p>
    </div>
  )
};